import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Location} from 'react-router-dom'
import {Nullable} from '../../../../../app/TypeHelpers'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {ApplyHistoryInfo, UserRegistrationApplyDetail} from '../../repository/NatGetUserRegistrationApply'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea
} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import {StyledTableCaption, TableRowName,} from '../../../../../styledComponents/adminPage/Table'
import {
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    StyledTableCell
} from '../../common/admin/NatAdminApplicationCommon'
import {HeadingAreaMessageParams} from '../../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {BackLink} from '../../../../../styledComponents/adminPage/Links'
import {
    MESSAGE_TYPE,
    RESIDENCE_STYLE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR
} from '../../../../../CodeMaster'
import {Check, Close} from '@mui/icons-material'
import {convertToRoomNumberForResident, getRandomKey} from '../../../../common/util/Natutil';
import AuthorityChecker from '../../../../../components/AuthorityChecker';
import {NatApplicationStatusComponent} from '../../common/admin/NatApplicationStatusComponent';
import {ApplyStatusInfo} from '../../repository/NatGetApplicationStatus';
import NatAdminUserRegistrationApplyApprovalDialog
    from '../../common/admin/NatAdminUserRegistrationApplyApprovalDialog';
import {Messages} from '../../../../../Messages';
import {
    NatPutApprovalUseRegistrationApplyRequest,
    NatPutApprovalUseRegistrationApplyResponse
} from '../../repository/NatPutApprovalUserRegistrationApplyRequest';
import NatAdminUserRegistrationApplyRejectionDialog
    from '../../common/admin/NatAdminUserRegistrationApplyRejectionDialog'
import {
    NatPutRejectionUserRegistrationApplyRequest
} from '../../repository/NatPutRejectionUserRegistrationApplyRequest'
import ReactDOM from 'react-dom'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface ApplyHistory {
    applyProcess: string,
    ridgeName: string,
    roomNumber: string,
    applyHistoryInfo: ApplyHistoryInfo
}

interface States {
    userRegistrationApplyDetail: UserRegistrationApplyDetail
    applyHistoryInfoList: ApplyHistory[]
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    rejectionReason: string
}

type DialogContentType = 'approval' | 'rejection'

class NatAdminUserRegistrationApplyPage extends Component<Props & AdminPagePropsSet, States> {
    ownUrl: string

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.state = {
            userRegistrationApplyDetail: {
                applyId: '',
                applyStatus: '',
                condominiumCd: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applicantFamilyNameKana: '',
                applicantFirstNameKana: '',
                applyDate: '',
                residentStyle: '',
                mailAddress: '',
                bankAccountNumberLast4Digits: '',
                applyHistoryInfo: [],
                version: 0
            },
            applyHistoryInfoList: [],
            dialogStatus: null,
            isLoadCompleted: false,
            rejectionReason: ''
        }

        this.ownUrl = this.props.location.pathname

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.convertApplyHistoryForApplyStatusComponent = this.convertApplyHistoryForApplyStatusComponent.bind(this)
        this.handleRejectionReasonChange = this.handleRejectionReasonChange.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()

            const {userRegistrationApplyDetail} = this.state
            const applyHistoryRecord = userRegistrationApplyDetail.applyHistoryInfo
                .map(applyStatusInfo => {
                    return {
                        applyProcess: applyStatusInfo.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value
                            ? RESIDENT_APPLY_PROCESS.APPLY.value
                            : RESIDENT_APPLY_PROCESS.RECEPTION.value,
                        ridgeName: userRegistrationApplyDetail.ridgeName,
                        roomNumber: userRegistrationApplyDetail.roomNumber,
                        applyHistoryInfo: applyStatusInfo
                    }
                })

            if(userRegistrationApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) {
                const applyHistoryInfo = {
                    applyProcess: RESIDENT_APPLY_PROCESS.RECEPTION.value,
                    ridgeName: '',
                    roomNumber: '',
                    applyHistoryInfo: {
                        historyId: 0,
                        registerDatetime: '',
                        applyStatus: '',
                        userRoleId: ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value,
                        userFamilyName: '',
                        userFirstName: '',
                        memo: ''
                    }
                }
                applyHistoryRecord.push(applyHistoryInfo)
            }

            this.setState({applyHistoryInfoList: applyHistoryRecord})

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    async getApplyInfo(): Promise<void> {
        const [userRegistrationApplyResponse] = await Promise.all([
            this.getUserRegistrationApply()
        ])

        if (userRegistrationApplyResponse) {
            ReactDOM.flushSync(() => {
                this.setState({
                    userRegistrationApplyDetail: userRegistrationApplyResponse
                })
            })
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getUserRegistrationApply(): Promise<Nullable<UserRegistrationApplyDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getUserRegistrationApply.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async handleDialogCancelClick(): Promise<void> {
        this.setState({dialogStatus: null})
    }

    async handleApprovalClick(): Promise<void> {
        this.setState({dialogStatus: 'approval'})
    }

    async handleRejectionClick(): Promise<void> {
        this.setState({dialogStatus: 'rejection'})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {userRegistrationApplyDetail, rejectionReason} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionUserRegistrationApplyRequest = {
                version: userRegistrationApplyDetail.version,
                rejectionReason: rejectionReason
            }

            const response: Nullable<NatPutApprovalUseRegistrationApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionUserRegistrationApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    state: {
                        initialMessage: {
                        title: null,
                        messageLevel: MESSAGE_TYPE.INFORMATION,
                        detail: Messages.IPCDA0004.toString('申請'),
                        }
                        ,
                    refreshToken: getRandomKey(),
                    }
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {userRegistrationApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalUseRegistrationApplyRequest = {
                version: userRegistrationApplyDetail.version
            }

            const response: Nullable<NatPutApprovalUseRegistrationApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalUserRegistrationApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    }
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleRejectionReasonChange(value: string): void {
        this.setState({rejectionReason: value})
    }

    convertApplyHistoryForApplyStatusComponent = (
        applyHistoryList: ApplyHistory[]
    ): ApplyStatusInfo[] => {
        return (
            applyHistoryList.map(applyHistory => {
                const {applyProcess, ridgeName, roomNumber, applyHistoryInfo} = applyHistory

                const rep = applyProcess ===  RESIDENT_APPLY_PROCESS.RECEPTION.value
                        ? ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.label
                        : ''

                return {
                    applyProcess: applyProcess,
                    applyStatus: applyHistoryInfo.applyStatus !== '' ? applyHistoryInfo.applyStatus : null,
                    plan: {
                        rep: rep,
                    },
                    actual: {
                        roleId: applyHistoryInfo.userRoleId,
                        ridgeName: ridgeName,
                        roomNumber: roomNumber,
                        familyName: applyHistoryInfo.userFamilyName,
                        firstName: applyHistoryInfo.userFirstName,
                        comment: applyHistoryInfo.memo,
                        irregularPattern: '',
                        registerDatetime: applyHistoryInfo.registerDatetime,
                    },
                    processName: (applyProcess === RESIDENT_APPLY_PROCESS.RECEPTION.value)
                        ? '承認'
                        : undefined
                }
            })
        )
    }

    renderApplyTable(): ReactNode {
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applicantFamilyNameKana,
            applicantFirstNameKana,
            residentStyle,
            mailAddress,
            bankAccountNumberLast4Digits,
        } = this.state.userRegistrationApplyDetail

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>物件名</TableRowName>
                            <StyledTableCell>
                                {condominiumName}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>部屋番号</TableRowName>
                            <StyledTableCell>
                                {`${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者 氏名</TableRowName>
                            <StyledTableCell>
                                {applicantFamilyName + ' ' + applicantFirstName
                                    + '（' + applicantFamilyNameKana + ' ' + applicantFirstNameKana + '）'}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>居住形態</TableRowName>
                            <StyledTableCell>
                                {RESIDENCE_STYLE.codeToEnumConstants(residentStyle).label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>メールアドレス</TableRowName>
                            <StyledTableCell>
                                {mailAddress}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>口座番号（下4桁）</TableRowName>
                            <StyledTableCell>
                                {bankAccountNumberLast4Digits}
                            </StyledTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {userRegistrationApplyDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate({
                            pathname: `/admin/applications/userRegistrationApplyList`,
                        })}
                    >
                        申請状況一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(userRegistrationApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={'APPROVAL-USER_REGISTRATION_APPLICATION'}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return <></>
        }

        return (
            <>
                <PageMainArea>
                    {this.renderApplyTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.userRegistrationApplyDetail.applyStatus}
                        applyStatusInfoList=
                            {this.convertApplyHistoryForApplyStatusComponent(this.state.applyHistoryInfoList)}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
                <NatAdminUserRegistrationApplyApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    isApproval={true}
                    onCancel={this.handleDialogCancelClick}
                    onCall={this.handleApprovalOkClick}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminUserRegistrationApplyRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionReasonChange}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

export default createAdminPage(NatAdminUserRegistrationApplyPage)
